import { HEADER_SWITCHER_PRODUCT_CLICKED, HEADER_SWITCHER_PRODUCT_HOVERED } from "constants/bigbrain-event-types";
import { useRef, useEffect } from "react";
import { StyledProductsSwitcher } from "./products-switcher.scss";
import { MAIN_PRODUCTS, ADDITIONAL_PRODUCTS } from "./consts";
import PictureComponent from "/components/core/picture/picture-component";
import { withGenericConfig } from "/contexts/generic-config-context";
import { trackEvent } from "/services/bigbrain-service";

const ProductsSwitcher = (props) => {
  const { translate, setShowproductsSwithcer, showproductsSwithcer } = props;

  const ref = useRef();

  useEffect(() => {
    const onPopUpClose = () => {
      if (showproductsSwithcer) {
        setShowproductsSwithcer(false);
      }
    };
    const checkIfClickedOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        onPopUpClose();
      }
    };
    document.addEventListener("click", checkIfClickedOutside);
    return () => {
      document.removeEventListener("click", checkIfClickedOutside);
    };
  }, [showproductsSwithcer, setShowproductsSwithcer]);

  const renderProduct = (product, openInDifferentTab) => {
    const linkProps = {
      href: product?.miniSiteLink,
      className: "product",
      onClick: () => {
        trackEvent(HEADER_SWITCHER_PRODUCT_CLICKED, {
          kind: product?.name
        });
      },
      onMouseEnter: () => {
        trackEvent(HEADER_SWITCHER_PRODUCT_HOVERED, {
          kind: product?.name
        });
      }
    };

    if (openInDifferentTab) {
      linkProps.target = "_blank";
    }

    return (
      <a {...linkProps}>
        <div className="icon-wrapper">
          <PictureComponent src={product?.iconLink} alt={product?.name} />
        </div>
        <div className="product-name">{product?.name}</div>
      </a>
    );
  };

  return (
    <StyledProductsSwitcher className="products-switcher" ref={ref}>
      <div className="main-products-title-wrapper">
        <div className="main-product-title">{translate("header.productsSwitcher.exploreFeaturedProducts")}</div>
      </div>
      <div className="main-products-wrapper">
        {MAIN_PRODUCTS.map((product, index) => renderProduct(product, false, index))}
      </div>
      <div className="separator-line" />
      <div className="additional-products-title-wrapper">
        <div className="additional-products-title">{translate("header.productsSwitcher.moreProducts")} </div>
      </div>
      <div className="additional-products-wrapper">
        {ADDITIONAL_PRODUCTS.map((product, index) => renderProduct(product, true, index))}
      </div>
    </StyledProductsSwitcher>
  );
};

export default withGenericConfig(ProductsSwitcher);
